import { useQuery } from '@tanstack/react-query';
import { IGallery } from '@clickersphere/core/entities/IGallery';
import GalleryService from '@clickersphere/core/services/GalleryService';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';
import { GALLERIES_QUERY_KEY } from './useGalleries';

export const GALLERY_DETAIL_QUERY_KEY = 'detail';

export type GalleryDetailQueryData = WithQueryStatus<IGallery>;

export function buildGalleryDetailKey(id: string): Array<string | undefined> {
  return [GALLERIES_QUERY_KEY, GALLERY_DETAIL_QUERY_KEY, id];
}

export function useGallery(id: string | undefined) {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: gallery,
    isSuccess: isGallerySuccess,
    isFetching: isGalleryFetching,
    isLoading: isGalleryLoading,
  } = useQuery({
    queryKey: buildQueryKey(buildGalleryDetailKey(id ?? '')),
    queryFn: async () => {
      const data = await GalleryService.getById(id as string);
      return data as GalleryDetailQueryData;
    },
    enabled: !!id && !!selectedTenantId,
    staleTime: 1000 * 60,
  });

  return {
    gallery,
    isGallerySuccess,
    isGalleryFetching,
    isGalleryLoading,
  };
}
